// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"a43e18e5","661":"865d2101"}[chunkId] + ".chunk.css";
};